module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-toyota.bbaa45bf.png";